import theme from "@/styles/theme";
import { Box, Typography } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import { LoaderCircleIcon, XCircleIcon } from "lucide-react";
import { CustomTooltip } from "./CustomTooltip";

type StatusIconProps = {
	color?: string;
	size?: number;
};

type Props = {
	isLoading: boolean;
	isError: boolean;
	size?: number;
};

export function LoadingIcon({
	color = blueGrey[400],
	size = 20,
}: StatusIconProps) {
	return (
		<Box
			sx={{
				width: "fit-content",
				height: "fit-content",
				"@keyframes spin": {
					"0%": { transform: "rotate(0deg)" },
					"100%": { transform: "rotate(360deg)" },
				},
			}}
		>
			<LoaderCircleIcon
				color={color}
				size={size}
				style={{ animation: "spin 1s linear infinite" }}
			/>
		</Box>
	);
}

export function ErrorIcon({
	color = theme.palette.error.main,
	size = 20,
}: StatusIconProps) {
	return (
		<CustomTooltip
			placement='bottom'
			offsetX={0}
			offsetY={-14}
			title={
				<Typography variant='body2' fontSize={"0.8rem"}>
					Erro de dados
				</Typography>
			}
		>
			<XCircleIcon size={size} color={color} />
		</CustomTooltip>
	);
}

export function StatusIndicator({ size = 24, isLoading, isError }: Props) {
	if (isLoading) return <LoadingIcon size={size} />;
	if (isError) return <ErrorIcon size={size} />;
	return null;
}
